module.exports = __webpack_public_path__ + "img/starthouse_bodyimage01.0565b1e2.jpg";